import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import { Button } from 'antd';
import Trash from '../../Assets/images/recycle-bin.png';
import Plus from '../../Assets/images/plus.png';
import TabMenu from './TabMenu';
import Breadcrumb from "../Breadcrumb/Breadcrumb";

const EditPackages = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { organization } = useContext(OrganizationContext);
  const [packageTests, setPackageTests] = useState([
    { category_name: '', lab_tests: [{ labtest_name: '' }] }
  ]);
  const [rcheckups, setRcheckups] = useState([]);

  const [formData, setFormData] = useState({
    package_name: '',
    description: '',
    price: '',
    mrp_price: '',
    preparation: '',
    organization_id: organization ? organization.id : '',
    Is_Active: '',
    visit_type: '', // Use a string or number for radio values
    genderwiseid: '', // Use a string or number for radio values
    keywords: '',
  });


  useEffect(() => {
    if (organization) {
      //loadCategories();
      loadcheckups();
      loadPackageDetails();
    }
  }, [organization]);




  const loadcheckups = () => {
    const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization

    // Construct the URL with the organization_id as a query parameter
    const url = new URL(authService.getApiUrl() + "genderwiseages");
    //url.searchParams.append("organization_id", organization); // Append the organization_id as a query parameter

    fetch(url, {
      method: "GET", // Set method to GET
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${token}`, // Include Authorization header with Bearer token if required
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setRcheckups(result.data); // Set the category data in state
      })
      .catch((err) => {
        console.log(err.message); // Handle any errors
      });
  };

  // const loadCategories = async () => {
  //   const token = authService.getCurrentadmin().token;
  //   const url = new URL(authService.getApiUrl() + 'category');
  //   url.searchParams.append('organization_id', organization);

  //   try {
  //     const response = await fetch(url, {
  //       method: 'GET',
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-Type': 'application/json; charset=UTF-8',
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     const result = await response.json();
  //     //setCategories(result.data);
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // In loadPackageDetails (fetch package and transform package_tests)
  const loadPackageDetails = async () => {
    const token = authService.getCurrentadmin().token;
    try {
      const response = await fetch(`${authService.getApiUrl()}labtestpackage/${id}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error('Failed to fetch package details');

      const result = await response.json();
      const packageData = result.data;

      setFormData({
        package_name: packageData.package_name || '',
        description: packageData.description || '',
        price: packageData.price || '',
        mrp_price: packageData.mrp_price || '',
        preparation: packageData.preparation || '',
        organization_id: packageData.organization_id || '',
        Is_Active: packageData.Is_Active === 'A',
        visit_type: packageData.visit_type?.toString() || '',
        genderwiseid: packageData.genderwiseid || '',
        keywords: packageData.keywords || '',
      });

      // Transform package_tests: split lab_test_name by comma and trim each item
      const transformedTests = (packageData.package_tests || []).map(test => ({
        category_name: test.category_name || '',
        lab_tests: (test.lab_test_name || '')
          .split(',')
          .map(name => ({ labtest_name: name.trim() }))
      }));

      setPackageTests(transformedTests);

    } catch (error) {
      console.error('Error fetching package details:', error);
    }
  };


  const loadLabTests = async (categoryId, index) => {
    const token = authService.getCurrentadmin().token;
    try {
      const response = await fetch(authService.getApiUrl() + 'catorgbasedtests', {
        method: 'POST',
        body: JSON.stringify({ organization_id: organization, category_id: categoryId }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      // setCatorgBasedTests((prevTests) => {
      //   const updatedTests = [...prevTests];
      //   updatedTests[index] = result.data || [];
      //   return updatedTests;
      // });
    } catch (err) {
      console.log(err.message);
    }
  };

  // const handlePackageTestChange = (index, field, value) => {
  //   setPackageTests((prevTests) => {
  //     const updatedPackageTests = [...prevTests];
  //     updatedPackageTests[index][field] = value;
  //     // When category changes, reset the lab_test_id and fetch the new lab tests
  //     if (field === 'category_id') {
  //       updatedPackageTests[index].lab_test_id = ''; // Reset lab_test_id
  //       loadLabTests(value, index); // Load new lab tests based on the selected category
  //     }

  //     return updatedPackageTests;
  //   });
  // };

  // const handleAddTest = () => {
  //   setPackageTests((prevTests) => [...prevTests, { category_id: '', lab_test_id: '' }]);
  //   setCatorgBasedTests((prevTests) => [...prevTests, []]);
  // };

  // const handleRemoveTest = (index) => {
  //   setPackageTests((prevTests) => {
  //     const updatedPackageTests = [...prevTests];
  //     updatedPackageTests.splice(index, 1);
  //     return updatedPackageTests;
  //   });

  //   setCatorgBasedTests((prevTests) => {
  //     const updatedCatorgBasedTests = [...prevTests];
  //     updatedCatorgBasedTests.splice(index, 1);
  //     return updatedCatorgBasedTests;
  //   });
  // };

  const [errors, setErrors] = useState({});

  const handleSubmit = async (event) => {
    event.preventDefault();

    const validationErrors = FormValidation(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const token = authService.getCurrentadmin().token;
      try {
        const response = await fetch(authService.getApiUrl() + 'labtestpackage/' + id, {
          method: 'PUT',
          body: JSON.stringify({
            organization_id: organization,
            package_name: formData.package_name,
            description: formData.description,
            price: formData.price,
            preparation: formData.preparation,
            mrp_price: formData.mrp_price,
            Is_Active: formData.Is_Active ? 'A' : 'I',
            package_tests: packageTests.map(test => ({
              category_name: test.category_name,
              lab_tests: test.lab_tests
                .map(t => t.labtest_name.trim())
                .filter(name => !!name)
                .join(', ')  // Join back to comma separated string
            })),
            visit_type: formData.visit_type,
            genderwiseid: formData.genderwiseid,
            keywords: formData.keywords,
          }),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to update package');
        }

        navigate('/admin/lab-management/packages');
      } catch (err) {
        console.log('Error:', err.message);
      }
    } else {
      console.log("form did not submit due to validation errors");
    }
  };

  const FormValidation = () => {
    const errors = {};
    const nameRex = /^[a-zA-Z\s\-]+$/;
    if (!formData.package_name) {
      errors.package_name = 'Package name is required';
    } else if (formData.package_name.length < 4) {
      errors.package_name = 'Package name must consists of 4 letters';
    } else if (!nameRex.test(formData.package_name)) {
      errors.package_name = 'Package name must contains letter only';
    }
    if (!formData.description) {
      errors.description = 'Description required';
    }
    if (!formData.price) {
      errors.price = 'Offer Price is required';
    }
    if (!formData.mrp_price) {
      errors.mrp_price = 'MRP Price is required';
    }
    if (!formData.genderwiseid) {
      errors.genderwiseid = 'Recommended Gender/Age is required';
    }


    packageTests.forEach((test, index) => {
      if (!test.category_name || test.category_name.trim() === '') {
        errors[`category_name_${index}`] = 'Category Name is required';
      }

      test.lab_tests.forEach((labTest, labIndex) => {
        if (!labTest.labtest_name || labTest.labtest_name.trim() === '') {
          errors[`labtest_name_${index}_${labIndex}`] = 'Lab Test Name is required';
        }
      });
    });

    if (!formData.visit_type) {
      errors.visit_type = 'Visit type is required';
    }

    return errors;
  }



  const handleCategoryChange = (index, value) => {
    const updated = [...packageTests];
    updated[index].category_name = value;
    setPackageTests(updated);
  };

  const handleLabTestChange = (catIndex, labIndex, value) => {
    const updated = [...packageTests];
    updated[catIndex].lab_tests[labIndex].labtest_name = value;
    setPackageTests(updated);
  };

  const addCategory = () => {
    setPackageTests([...packageTests, { category_name: '', lab_tests: [{ labtest_name: '' }] }]);
  };


  const addLabTest = (catIndex) => {
    const updated = [...packageTests];
    updated[catIndex].lab_tests.push({ labtest_name: '' });
    setPackageTests(updated);
  };



  const transformPackageTests = (package_tests) => {
    const grouped = {};

    package_tests.forEach((item) => {
      const category = item.category_name;

      if (!grouped[category]) {
        grouped[category] = {
          category_name: category,
          lab_tests: []
        };
      }

      grouped[category].lab_tests.push({
        labtest_name: item.lab_test_name
      });
    });

    return Object.values(grouped);
  };

  const removeCategory = (index) => {
    if (packageTests.length === 1) return; // prevent removing last category
    const updated = [...packageTests];
    updated.splice(index, 1);
    setPackageTests(updated);
  };

  const removeLabTest = (catIndex, labIndex) => {
    if (packageTests[catIndex].lab_tests.length === 1) return; // prevent removing last lab test
    const updated = [...packageTests];
    updated[catIndex].lab_tests.splice(labIndex, 1);
    setPackageTests(updated);
  };


  return (
    <div className='main-container'>
      <div className='container-fluid'>
        <Breadcrumb />
        <TabMenu name="packages" />
        <div className='category-table'>
          <div className='flex-cont add-cat'>
            <div className='heading'>
              <h3>Edit Package</h3>
            </div>
          </div>
          <div className="card">
            <div className="card-body custom-edit-service">
              <form className="needs-validation clearfix" onSubmit={handleSubmit}>
                <div className="addtest-fields mb-3">
                  <div className="flex-cont">
                    <div className="full-cont">
                      <div className="form-group">
                        <label>
                          Package Name
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="package_name"
                          value={formData.package_name}
                          onChange={(e) => handleInputChange(e)}
                        />
                        {errors.package_name && (<span className="error-message">{errors.package_name}</span>)}

                      </div>
                    </div>

                    {packageTests.map((category, catIndex) => (

                      <React.Fragment key={`category-${catIndex}`}>
                        <div className="row-cont add-packages-set" >
                          <div className="full-cont package-full-cont">
                            <div className="form-group">
                              <label>
                                Category Name <span className="text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                value={category.category_name}
                                onChange={(e) => handleCategoryChange(catIndex, e.target.value)}
                              />
                              {errors[`category_name_${catIndex}`] && (
                                <span className='errors'>{errors[`category_name_${catIndex}`]}</span>
                              )}
                            </div>
                          </div>
                          <div className="action-icon">
                            <Button
                              type="text"
                              icon={<img src={Plus} alt="Add" style={{ width: 18, height: 18 }} />}
                              onClick={addCategory}
                            />
                          </div>
                          <div className="action-icon">
                            <Button
                              type="text"
                              icon={<img src={Trash} alt="Delete" style={{ width: 18, height: 18 }} />}
                              onClick={() => removeCategory(catIndex)}
                            />
                          </div>
                        </div>
                        {category.lab_tests.map((labtest, labIndex) => (
                          <div className="row-cont add-packages-set" key={labIndex}>
                            <div className="half-cont package-half-cont">
                              <div className="form-group">
                                <label>
                                  Lab Test Name <span className="text-danger">*</span>
                                </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  value={labtest.labtest_name}
                                  onChange={(e) => handleLabTestChange(catIndex, labIndex, e.target.value)}
                                />
                                {errors[`labtest_name_${catIndex}_${labIndex}`] && (
                                  <span className='errors'>{errors[`labtest_name_${catIndex}_${labIndex}`]}</span>
                                )}
                              </div>
                            </div>
                            <div className="action-icon">
                              <Button
                                type="text"
                                icon={<img src={Plus} alt="Add" style={{ width: 18, height: 18 }} />}
                                onClick={() => addLabTest(catIndex)}
                              />
                            </div>
                            <div className="action-icon">
                              <Button
                                type="text"
                                icon={<img src={Trash} alt="Delete" style={{ width: 18, height: 18 }} />}
                                onClick={() => removeLabTest(catIndex, labIndex)}
                              />
                            </div>
                          </div>
                        ))}


                      </React.Fragment>
                    ))}

                  </div>
                </div>
                <div className="addtest-fields mb-3">
                  <div className="flex-cont">
                    <div className="full-cont">
                      <div className="form-group">
                        <label>
                          Description
                          <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          name="description"
                          rows="4"
                          // required
                          value={formData.description}
                          onChange={(e) => handleInputChange(e)}
                        />
                        {errors.description && (<span className="error-message">{errors.description}</span>)}
                      </div>
                    </div>

                    <div className="half-cont">
                      <div className="form-group">
                        <label>
                          Offer Price
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="number"
                          name="price"
                          value={formData.price}
                          onChange={(e) => handleInputChange(e)}
                        />
                        {errors.price && (<span className="errors">{errors.price}</span>)}
                      </div>
                    </div>
                    <div className="half-cont">
                      <div className="form-group row">
                        <label>
                          MRP Price
                          <span className="text-danger">*</span>
                        </label>
                        <div className="inline-flex">
                          <span className="input-group-text">&#8377;</span>
                          <input
                            type="text"
                            className="form-control"
                            name="mrp_price"
                            value={formData.mrp_price}
                            onChange={(e) => handleInputChange(e)}
                          />
                          <span className="input-group-text">.00</span>
                        </div>
                        {errors.mrp_price && <span className='errors' >{errors.mrp_price}</span>}
                      </div>
                    </div>

                    <div className="half-cont">
                      <div className="form-group">
                        <label>
                          Preparation
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter message"
                          name="preparation"
                          value={formData.preparation}
                          onChange={(e) => handleInputChange(e)}
                        />
                        {errors.preparation && <span className='errors' >{errors.preparation}</span>}
                      </div>
                    </div>
                    <div className="half-cont">
                      <div className="form-group">
                        <label>
                          Recommended Gender/Age <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select form-control"
                          name="genderwiseid"
                          // required
                          value={formData.genderwiseid}
                          onChange={handleInputChange}
                        >
                          <option value="">--Select--</option>
                          {rcheckups.map((item, i) => (
                            <option value={item.id} key={i}>{item.gender} - {item.age}</option>
                          ))}
                        </select>
                        {errors.genderwiseid && <span className='errors' >{errors.genderwiseid}</span>}
                      </div>
                    </div>
                    <div className="full-cont">
                      <div className="form-group">
                        <label>
                          Keywords
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter message"
                          name="keywords"
                          value={formData.keywords}
                          onChange={handleInputChange}
                        />
                        {errors.keywords && <span className='errors' >{errors.keywords}</span>}
                      </div>
                    </div>

                    {/* Radio buttons for Home and Hospital Visit */}
                    <div className="half-cont">
                      <div className="form-group">
                        <label>Visit Type
                          <span className="text-danger">*</span>
                        </label>
                        <div className='radio-sec'>
                          <div className='radio-btn'>
                            <label>
                              <input
                                type="radio"
                                name="visit_type"
                                value="1"
                                checked={formData.visit_type === '1'}
                                onChange={handleInputChange}
                              />
                              Home Visit
                            </label>
                          </div>
                          <div className='radio-btn'>
                            <label>
                              <input
                                type="radio"
                                name="visit_type"
                                value="2"
                                checked={formData.visit_type === '2'}
                                onChange={handleInputChange}
                              />
                              Hospital Visit
                            </label>
                          </div>
                        </div>
                        {errors.visit_type && <span className='errors' >{errors.visit_type}</span>}
                      </div>
                    </div>

                    <div className="full-cont special-case-cont">
                      <div className='form-group'>
                        <label className="custom-checkbox">
                          <input
                            type="checkbox"
                            name="Is_Active"
                            checked={formData.Is_Active}
                            onChange={handleInputChange}
                            value="A"

                          />
                          <span className="checkmark"></span>
                          <label>Status</label>
                        </label>
                        {/* {errors.Is_Active && <span className='errors' >{errors.Is_Active}</span>} */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="submit-section">
                  <button className="btn btn-primary submit-btn" type="submit" >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPackages;
